import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = ['signature', 'signButton', 'submitButton']

  sign() {
    this.signatureTarget.classList.remove('hidden')
    this.signButtonTarget.classList.add('hidden')
    this.submitButtonTarget.removeAttribute('disabled')
    this.submitButtonTarget.classList.remove('t-btn-disabled')
  }

  submit() {
    this.dispatch('signed')
  }
}
